// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement, useEffect, useState } from "react";
import { Layout, Button } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import LinearProgress from "@material-ui/core/LinearProgress";
import { isMobile } from 'react-device-detect';
import { useAlert } from "react-alert";
import { MainLayout, SPContent } from "./GlobalStyles";
import { Header, SideBar } from "./index";
import { getAuthState, getAppState } from "../redux/selectors";
import Loading from "./Loading";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function MainContainer({ children }: any): ReactElement {
  const { currentUser } = useSelector(getAuthState);
  const { i18n } = useTranslation();
  const { locale, loading } = useSelector(getAppState);
  const [collapsedSideBar, setCollapsedSideBar] = useState<boolean>(false);
  const alert = useAlert();

  useEffect(() => {
    i18n.changeLanguage(locale);
    const localStorageData = localStorage.getItem("permission_alert");
    if (isMobile && localStorageData === null) {
      alert.show(
        <span style={{ fontSize: 14, textTransform: "initial" }}>Pleae make sure your browser can access your location!</span>,
        {
          onClose: () => {
            console.log("onClose");
            localStorage.setItem("permission_alert", "yes");
          },
        },
      );
    }
  }, []);

  const onSidebarCollapsed = (value: boolean) => {
    // console.log(value);
    setCollapsedSideBar(value)
  }

  const hideSidebarIfOpened = (event: any) => {
    if (event.target.classList.contains("no-hide-sidebar")) return;
    if (isMobile && collapsedSideBar === false) {
      setCollapsedSideBar(true)
    }
  }

  if (currentUser) {
    return (
      <MainLayout onClick={hideSidebarIfOpened}>
        <SideBar collapsed={collapsedSideBar} onCollasped={onSidebarCollapsed} />
        <Layout>
          <Header />
          {loading && <Loading />}
          <SPContent>{children}</SPContent>
        </Layout>
      </MainLayout>
    );
  }
  return (
    <Layout>
      <SPContent>{children}</SPContent>
    </Layout>
  );
}
